module.exports = __webpack_public_path__ + "img/money.a8ca75ed.svg";